import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthenticationGuardService } from 'app/core/authentication-guard.service';
import { environment } from 'environments/environment';

const routes: Routes = [
  {
    path: 'assetgroup',
    loadChildren: () => import('app/assetgroup/assetgroup.module').then(m => m.AssetgroupModule),
    canActivate: [AuthenticationGuardService]
  },
  {
    path: 'provider-profile',
    loadChildren: () => import('app/provider-profile/provider-profile.module').then(m => m.ProviderProfileModule),
    canActivate: [AuthenticationGuardService]
  },
  {
    path: 'scope/:scope/metagroup/:id/assetgroups/:assetgroupId/assets/:assetId',
    redirectTo: 'assetgroup/scope/:scope/metagroup/:id/assetgroups/:assetgroupId/assets/:assetId',
    pathMatch: 'full'
  },
  {
    path: 'scope/:scope/metagroup/:id/assetgroups/:assetgroupId',
    redirectTo: 'assetgroup/scope/:scope/metagroup/:id/assetgroups/:assetgroupId',
    pathMatch: 'full'
  },
  {
    path: 'scope/:scope/metagroup/:id/assetgroups',
    redirectTo: 'assetgroup/scope/:scope/metagroup/:id/assetgroups',
    pathMatch: 'full'
  },
  { path: 'login', loadChildren: () => import('app/login/login.module').then(m => m.LoginModule) },
  { path: '', redirectTo: 'provider-profile/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'provider-profile/dashboard', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes, { enableTracing: !environment.production, preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
